import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';
import {
    defaultSAL3050_R01DetailDto,
    defaultSAL3050_R01HeaderDto,
    SAL3050_R01DetailDto,
    SAL3050_R01Filter,
    SAL3050_R01HeaderDto,
} from './Dto_SAL3050_R01';

export const defaultSAL3050_R01Filter: SAL3050_R01Filter = {
    compCd: '',
    dateRange: {
        from: new Date(new Date().getFullYear(), 0, 1),
        to: new Date(),
    },
    areaCd: 'all',
    customCd: '',
    customNm: '',
};

export interface Store_SAL3050_R01 {
    SAL3050_R01Filter: SAL3050_R01Filter;
    SAL3050_R01PastFilter: SAL3050_R01Filter;
    setSAL3050_R01Filter: (filter: Partial<SAL3050_R01Filter>) => void;
    setSAL3050_R01PastFilter: (filter: SAL3050_R01Filter) => void;

    SAL3050_R01List: SAL3050_R01HeaderDto[];
    setSAL3050_R01List: (list: SAL3050_R01HeaderDto[]) => void;

    selectedSAL3050_R01: SAL3050_R01HeaderDto | undefined;
    setSelectedSAL3050_R01: (row: SAL3050_R01HeaderDto | undefined) => void;
    initSelectedSAL3050_R01: () => void;

    SAL3050_R01DetailList: SAL3050_R01DetailDto[];
    setSAL3050_R01DetailList: (list: SAL3050_R01DetailDto[]) => void;

    columnState: ColumnState[] | null;
    setColumnState: (state: ColumnState[] | null) => void;
    detailColumnState: ColumnState[] | null;
    setDetailColumnState: (state: ColumnState[] | null) => void;

    scrollTop: number | null;
    setScrollTop: (top: number | null) => void;
    detailScrollTop: number | null;
    setDetailScrollTop: (top: number | null) => void;

    allCount: number;
    setAllCount: (count: number) => void;

    initData: () => void;
}

export const useSAL3050_R01Store = create<Store_SAL3050_R01>((set) => ({
    SAL3050_R01Filter: defaultSAL3050_R01Filter,
    SAL3050_R01PastFilter: defaultSAL3050_R01Filter,
    setSAL3050_R01Filter: (update) =>
        set((state) => ({ SAL3050_R01Filter: { ...state.SAL3050_R01Filter, ...update } })),
    setSAL3050_R01PastFilter: (filter) => set({ SAL3050_R01PastFilter: filter }),

    SAL3050_R01List: [],
    setSAL3050_R01List: (list) => set({ SAL3050_R01List: list }),

    selectedSAL3050_R01: undefined,
    setSelectedSAL3050_R01: (row) => set({
        selectedSAL3050_R01: row,
        SAL3050_R01DetailList: [],
        detailScrollTop: null,
    }),
    initSelectedSAL3050_R01: () => set({
        selectedSAL3050_R01: undefined,
        SAL3050_R01DetailList: [],
    }),

    SAL3050_R01DetailList: [],
    setSAL3050_R01DetailList: (list) => set({
        SAL3050_R01DetailList: list.map((item, idx) => ({
            ...item,
            valueIndex: idx + 1,
        })),
    }),

    columnState: null,
    setColumnState: (state) => set({ columnState: state }),
    detailColumnState: null,
    setDetailColumnState: (state) => set({ detailColumnState: state }),

    scrollTop: null,
    setScrollTop: (top) => set({ scrollTop: top }),
    detailScrollTop: null,
    setDetailScrollTop: (top) => set({ detailScrollTop: top }),

    allCount: 0,
    setAllCount: (count) => set({ allCount: count }),

    initData: () => set({
        SAL3050_R01Filter: defaultSAL3050_R01Filter,
        SAL3050_R01PastFilter: defaultSAL3050_R01Filter,
        SAL3050_R01List: [],
        selectedSAL3050_R01: undefined,
        SAL3050_R01DetailList: [],
        columnState: null,
        detailColumnState: null,
        scrollTop: null,
        detailScrollTop: null,
        allCount: 0,
    }),
}));
